import * as crypto from "node:crypto";
const getCacheKey = (input) => {
  return crypto.createHash("sha1").update(JSON.stringify(input)).digest("hex");
};
export {
  getCacheKey
};
//# sourceMappingURL=getCacheKey.js.map
